import React from 'react';
import { useSelector } from 'react-redux';

import SmartImage from 'dpl/components/SmartImage';
import useResourceQuery from 'dpl/shared/fetching/hooks/useResourceQuery';
import { breedLocationInfoResourceDefinition } from 'dpl/shared/utils/tptConnectResourceDefinitions';

import dogComputerSvg from 'dpl/assets/dog_computer.svg';

import BreedLocationInfoSkeleton from './BreedLocationInfoSkeleton';

export default function BreedLocationInfo() {
  const { breedId, citySlug, stateSlug } = useSelector(({ server }) => server);

  const { isFetching, value } = useResourceQuery(
    breedLocationInfoResourceDefinition({ breedId, citySlug, stateSlug })
  );

  const breedInfo = value.data?.breed_info;

  if (isFetching) {
    return <BreedLocationInfoSkeleton />;
  }

  if (!breedInfo) return null;

  return (
    <div className="BreedLocationInfo stone-700 bg-sand">
      <div className="container-xxl">
        <div className="row pv12 pv16-md">
          <div className="col-12 col-md-6">
            <h5 className="font-24 md:font-32 mb6 mb5-md">About Good Dog</h5>
            <div className="tc tl-l">
              <SmartImage src={dogComputerSvg} width="290px" height="217px" />
            </div>
          </div>
          <div className="col-12 col-md-6 self-center">
            <p className="font-16 md:font-20 md:font-serif mt6 mt0-md ph6-xl">
              {breedInfo}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
